import { useState } from "react";
import * as S from "./style";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
import PayInvoice from "../Update";
import Toast from "../../../../components/Toast";
//Icons
import { Circle, CaretRight } from "@phosphor-icons/react";
//hooks
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//utils
import FormatarData from "utils/FormatData";
//Interface
import { IInstallmentsDetail } from "Interfaces/IOrder";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  dataInvoices: IInstallmentsDetail[];
}

export default function Invoices({
  isOpenModalDetails,
  setModalClose,
  dataInvoices,
}: IDetails) {
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [installmentId, setInstallmentId] = useState<number | null>(null);
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });

  const clickInvoices = (id: number) => {
    setInstallmentId(id);
    toggleModalVisibility("payment");
  };

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Resumo de faturas"
        subTitle="Veja o resumo completo das faturas do cliente."
        setModalClose={setModalClose}
      >
        <S.Content>
          {dataInvoices.map((val) => {
            const isPaid = val.status === "Pago";

            return (
              <S.SectionButton
                isPaid={isPaid}
                onClick={() => clickInvoices(val.id)}
              >
                <S.ContentInfor>
                  <S.TitleButton>
                    <p>
                      {FormatarData(
                        val.due_date || "-",
                        "only-month"
                      ).toUpperCase()}
                    </p>
                  </S.TitleButton>

                  <S.Infor>
                    <p>{FormatarData(val.due_date || "-", "default")}</p>
                  </S.Infor>
                  <S.Status isPay={isPaid}>
                    <Circle size={8} weight="fill" />
                    <p>{val.status}</p>
                  </S.Status>
                </S.ContentInfor>

                <CaretRight size={16} weight="bold" />
              </S.SectionButton>
            );
          })}
        </S.Content>

        <PayInvoice
          selectedId={installmentId}
          isOpenModalCustomer={isOpenModal("payment")}
          setModalClose={() => toggleModalVisibility("payment")}
          setToastOpen={() => toggleModalVisibility('open-toast')}
          setToastData={setToastData}
        />

        <Toast
          openToast={isOpenModal('open-toast')}
          closeToast={() => toggleModalVisibility('open-toast')}
          message={toastData.message}
          status={toastData.status}
        />
      </LayoutDetails>
    );
  }
  return null;
}
